var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.signers.length
    ? _c(
        "div",
        { staticClass: "approvers" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_signatures()))]),
          _vm._v(" "),
          _vm._l(_vm.signers, function(signer) {
            return _c(
              "div",
              {
                key: signer.r,
                class: [
                  "sign-row",
                  {
                    rejected: signer.status === "canceled",
                    confirm: signer.status === "confirmed",
                    pending: signer.isPendingSlot
                  }
                ]
              },
              [
                signer.status === "confirmed"
                  ? _c("span", [
                      _c("img", {
                        attrs: { src: "/static/img/level-success.svg" }
                      })
                    ])
                  : signer.isPendingSlot
                  ? _c("span", { staticClass: "hourglass-icon" }, [
                      _c("img", {
                        attrs: { src: "/static/img/hourglass-pending.svg" }
                      })
                    ])
                  : signer.isFutureSlot
                  ? _c("span", { staticClass: "hourglass-icon" }, [
                      _c("img", {
                        attrs: { src: "/static/img/hourglass-muted.svg" }
                      })
                    ])
                  : _c("span", [
                      _vm.amlState && Number(signer.level) === 1
                        ? _c("img", {
                            attrs: { src: "/static/img/level-success.svg" }
                          })
                        : _c("img", {
                            attrs: { src: "/static/img/level-cross.svg" }
                          })
                    ]),
                _vm._v(" "),
                signer.isPendingSlot
                  ? [
                      _c("strong", [
                        _vm._v(
                          _vm._s(signer.name_of) +
                            " – " +
                            _vm._s(_vm.i18n.lbl_check_sign())
                        )
                      ])
                    ]
                  : signer.isFutureSlot
                  ? [
                      _c("span", [
                        _vm._v(
                          _vm._s(signer.name_of) +
                            " – " +
                            _vm._s(_vm.i18n.lbl_check_sign())
                        )
                      ])
                    ]
                  : [
                      _c("span", [_vm._v(_vm._s(signer.name_of))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(signer.approver_email))]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(signer.approved_at))]),
                      _vm._v(" "),
                      _vm.amlState && Number(signer.level) === 1
                        ? [
                            _vm._v("\n         \n        "),
                            _c(
                              "span",
                              {
                                class: [
                                  "aml-status",
                                  {
                                    "aml-status--pending":
                                      _vm.isAutoAMLCheckPending
                                  }
                                ]
                              },
                              [
                                _c("md-icon", { staticClass: "scsc" }, [
                                  _vm._v("search")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("strong", [_vm._v(_vm._s(_vm.amlState))])
                          ]
                        : _vm._e()
                    ]
              ],
              2
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10411702", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10411702","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/widrawalRequest/CheckSignList.vue
// module id = /qAH
// module chunks = 1